import {BaseContainerModel} from '../base-container.model';
import {
  bl_fi_mst_cashbook_hdr_RowClass,
  bl_fi_mst_cashbook_hdr_RowInterface,
  bl_fi_mst_cashbook_ext_RowClass
} from '../../dbschema/index';

export class CashbookContainerModel extends BaseContainerModel {
  bl_fi_mst_cashbook_hdr: bl_fi_mst_cashbook_hdr_RowInterface = new bl_fi_mst_cashbook_hdr_RowClass();
  bl_fi_mst_cashbook_exts: bl_fi_mst_cashbook_ext_RowClass[] = [];
}
